module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "part04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("IV"), _c('br'), _vm._v("FROM CHEROKEE TO COMANCHE")]), _vm._v(" "), _c('p', {
    staticClass: "noindentm"
  }, [_c('em', [_vm._v("Commissioner: ‘Where are the prisoners you promised to bring into this Council?")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('em', [_vm._v("Comanche Chief: ‘We have brought in the only one we had; the others are with other tribes. How … do you like the answer?")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "noindentm"
  }, [_vm._v("‘"), _c('em', [_vm._v("The Indians … approached … the town … riding very nearly at full speed, and in the shape of a half-moon.… The citizens … had to flee to the bay where most of them were saved by getting into a lighter.")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" H. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentm"
  }, [_vm._v("‘"), _c('em', [_vm._v("Many of the arms, and most of the saddles and baggage were left. We ate, drank and rested for a moment; I then had a bon-fire made of most of the Indian trumpery.")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_c('em', [_vm._v("Captain J")]), _vm._v(". R. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNNINGHAM")]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a557f15","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part04.vue
// module id = 138
// module chunks = 0